<template>
    <div ref="info" class="ledger-amount-info">
        <img :src="infoImg" alt="" @mouseenter="mouseIn" @mouseout="mouseOut">
        <div  v-if="tipStatus.price" class="amount-info">
            <div>
                <div class="title">
                    請款
                </div>
                <div class="amount">
                    {{toCurrency(data.quote)}}
                </div>
            </div>
            <div>
                <div class="title">
                    成本
                </div>
                <div class="amount">
                    {{toCurrency(data.amount)}}
                </div>
            </div>
        </div>
        <!-- <border-tips v-if="tipStatus.price" msg="報價說明文案報價說明文案報價說明文案。" width="117px"></border-tips> -->
    </div>
</template>

<script>
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
export default {
    data () {
        return {
            show: 0,
            infoImg: require('@/assets/img/icon/info_gray.svg'),
            tipStatus: {
                price: false,
            },
        }
    },
    props: {
        data: Object,
    },
    methods: {
        mouseIn: function () {
            this.infoImg = require('@/assets/img/icon/info_blue.svg')
            this.tipStatus.price = true
            this.$refs.info.style.zIndex = 2
        },
        mouseOut: function () {
            this.infoImg = require('@/assets/img/icon/info_gray.svg')
            this.tipStatus.price = false
            this.$refs.info.style.zIndex = 1

        },
    },
    components: {
        borderTips
    }
}
</script>
<style lang="scss"  >
    .ledger-amount-info{
        position: absolute;
        top: 1px;
        right: -24px;
        z-index: 1;
        .amount-info{
            position: relative;
            left: 35px;
            box-shadow: 1px 3px 8px 0 rgba(3, 6, 52, 0.08);
            border: solid 1px #3942b5;
            background-color: #ffffff;
            padding: 16px 16px 20px;
            border-radius: 4px;
            min-width: 135px;
            height: 84px;
            box-sizing: border-box;
            text-align: left;
            line-height: 1.7;
            >div{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                .amount{
                    text-align: right;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/ledgerTipsHover.vue